import { Course, DefaultCourse } from '../courses/course';

export interface Image {
  id: number;
  file: File | null;
  url?: string;
  course_id: number;
  course_name: string;
}

const DEFAULT_IMAGE: Image = {
  id: -1,
  file: null,
  url: '',
  course_id: 0,
  course_name: '',
};

export function DefaultImage(): Image {
  return JSON.parse(JSON.stringify(DEFAULT_IMAGE));
}